export default {
  brand: {
    fileShare: '文件分享'
  },
  common: {
    loading: '加载中..',
    confirm: '确认',
    cancel: '取消',
    download: '下载',
    downloadAll: '全部下载',
    downloadSelected: '下载选中',
    selectAll: '全选',
    deselectAll: '取消选中',
    rootDirectory: '根目录',
    createTime: '创建时间',
    expireTime: '过期时间',
    totalSize: '总大小',
    noFiles: '没有文件'
  },
  share: {
    expired: '分享的文件已过期',
    invalidLink: '无效的分享链接',
    needVerifyCode: '请输入提取码',
    verifyCodeLabel: '提取码',
    verifyCodePlaceholder: '请输入提取码',
    extractFiles: '提取文件',
    extractionCodeError: '提取码错误',
    uuidRequestFailed: '下载请求失败',
    selectFilesFirst: '请先选择文件',
    unknownError: '未知错误'
  },
  error: {
    networkError: '网络错误',
    connectionFailed: '无法连接到分享设备，可能设备关机、休眠或服务区发生变更，请联系分享者',
    outdatedLink: '无法连接到分享设备，可能使用了过时的分享链接，请联系分享者升级系统至v2.0.10版本以上、APP至v2.1.5版本以上，并重新复制分享链接',
    registryError: '获取公网穿透设置错误，无法连接到Registry服务',
    missingRegion: '分享链接缺少服务区信息，请联系分享者升级系统至v2.0.10版本以上、APP至v2.1.5版本以上，并重新复制分享链接'
  }
}
